//
//
//
//

export default {
  props: {
    num: {
      type: Number, default: 0
    },
    pieData: {
      type: Array, default: () => []
    },
    showLabel: {
      type: Boolean, default: false
    },
    colorArray: {
      type: Array, default: () => ['rgba(46, 153, 135, 1)', 'rgba(199, 52, 76, 1)']
    },
    radius: {
      type: Number, default: 50
    },
    inRadius: {
      type: Number, default: 90
    },
    value: {
      type: String, default: 'value'
    }
  },
  data () {
    return {
      newPieData: [],
      pieCharts: null // 图表实例
    }
  },
  watch: {
    // 监听屏幕宽度的变化
    '$store.state.screenWidth' (newV) {
      this.pieCharts?.resize()
    },
    pieData: {
      handler (newVal) {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.getData()
    })
  },
  beforeDestroy () {
    this.pieCharts?.clear() // 清空当前实例
    this.pieCharts?.dispose() // 销毁图表
    this.pieCharts = null
  },
  methods: {
    getData () {
      this.newPieData = []
      this.pieData?.forEach((item) => {
        this.newPieData.push({
          name: item.symbol,
          value: item[this.value],
          rate: this.showLabel ? item.rate : null
        })
      })
      this.getPieCharts()
    },
    getPieCharts () {
      if (!this.pieCharts) this.pieCharts = this.$echarts.init(document.getElementsByClassName(`fundsFlow-pie-charts-${this.num}`)[0])
      const that = this
      const option = {
        // tooltip: {
        //   confine: true,
        //   backgroundColor: 'rgba(0,0,0,.7)',
        //   textStyle: {
        //     color: '#fff',
        //     fontSize: 14
        //   },
        //   axisPointer: {
        //     type: 'none'
        //   },
        //   formatter: (params) => {
        //     return `<div class="tooltip-box">
        //     <div class="box">
        //     ${params.marker}
        //     </div>
        //     <div>
        //       <div class="item"><span></span>${params.name}</div>
        //       <div class="item">${this.num2CurrencyNo(params.data.value)}</div>
        //       </div>
        //       </div>`
        //   }
        // },
        legend: {
          show: false
        },
        color: that.colorArray,
        series: [
          {
            name: '',
            type: 'pie',
            radius: [that.radius + '%', that.inRadius + '%'],
            startAngle: 120, // 起始角度
            // avoidLabelOverlap: false,
            itemStyle: {
              borderRadius: 0,
              borderColor: '#fff',
              borderWidth: 3
            },
            label: {
              show: that.showLabel,
              formatter: (params) => {
                return [`{a|${params.name}}`, `{b|${params.data.rate}}`].join('\n')
              },
              rich: {
                a: {
                  color: '#3D3D3D',
                  lineHeight: 24,
                  fontSize: 17,
                  fontWeight: 600
                },
                b: {
                  color: '#3D3D3D',
                  lineHeight: 19,
                  fontSize: 16,
                  fontFamily: 'WikiFX'
                }
              }
            },
            labelLine: {
              show: that.showLabel
            },
            // emphasis: {
            //   label: {
            //     show: false,
            //     fontSize: '16',
            //     fontFamily: 'WikiFX',
            //     formatter: params => params.name
            //   }
            // },
            data: that.newPieData
          }
        ]
      }
      that.pieCharts?.clear()
      that.pieCharts?.setOption(option, true)
    }
  }
}
